import { isEmpty } from 'lodash';
import dayjs from 'dayjs';

export const formatDate = (date, format) => {
  if (!isEmpty(date)) {
    // Remove timestamp.
    const parsedDate = date.split('T')[0];

    // Format date if format exists.
    return format ? dayjs(parsedDate).format(format) : date;
  } else {
    return date;
  }
};
